module.exports = __webpack_public_path__ + "static/media/nissan-vial.d1010f9a.svg";